// MACHINERY V2 (Stroje) — the 13px form glyph set (M2.6).
//
// Spec: MACHINERY_V2_IMPLEMENTATION_TICKET.md §8 M2.6 ("teal glyph + mono
// eyebrow"). Reference impl: design_handoff_machinery_v3/machinery-sr.jsx
// lines 691-702 — the `_g` glyph props object and its eight paths, copied
// stroke-for-stroke. Artboards 0702 / 0703 (create) and 0700 / 0701 (detail).
//
// These are FORM glyphs, not icons: 13x13, 1.4 stroke, currentColor, aria-hidden.
// The label owns the accessible name — the glyph is decoration next to it.
// M2.7's CustomMachineDialog consumes the same set (the kit is shared with the
// Creative Designer).
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

const g = {
  width: 13,
  height: 13,
  viewBox: "0 0 13 13",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export const DocGlyph: React.FC = () => (
  <svg {...g}>
    <path d="M3 1 L9 1 L11 3 L11 12 L3 12 Z" />
    <line x1="4.5" y1="5" x2="9.5" y2="5" />
    <line x1="4.5" y1="7.5" x2="9.5" y2="7.5" />
    <line x1="4.5" y1="10" x2="7.5" y2="10" />
  </svg>
);

export const NoteGlyph: React.FC = () => (
  <svg {...g}>
    <rect x="2" y="2" width="9" height="9" rx="1" />
    <line x1="4" y1="5" x2="9" y2="5" />
    <line x1="4" y1="7" x2="9" y2="7" />
    <line x1="4" y1="9" x2="7" y2="9" />
  </svg>
);

export const CalendarGlyph: React.FC = () => (
  <svg {...g}>
    <rect x="2" y="3" width="9" height="8" rx="1" />
    <line x1="2" y1="5.5" x2="11" y2="5.5" />
    <line x1="5" y1="2" x2="5" y2="4" />
    <line x1="8" y1="2" x2="8" y2="4" />
  </svg>
);

export const WrenchGlyph: React.FC = () => (
  <svg {...g}>
    <path d="M9.5 1.5 a2.5 2.5 0 0 0 -2.7 3.5 L2.4 9.4 a1.1 1.1 0 1 0 1.5 1.5 L8.3 6.5 A2.5 2.5 0 0 0 11.5 3.4 L9.9 5 L8.4 4.6 L8 3.1 Z" />
  </svg>
);

export const PaperclipGlyph: React.FC = () => (
  <svg {...g}>
    <path d="M10 5 L5.5 9.5 a2 2 0 1 1 -2.8 -2.8 L8.5 1 a3 3 0 0 1 4.2 4.2 L7 11" />
  </svg>
);

export const AlertGlyph: React.FC = () => (
  <svg {...g}>
    <path d="M6.5 1.5 L12 11 L1 11 Z" />
    <line x1="6.5" y1="5" x2="6.5" y2="7.5" />
    <circle cx="6.5" cy="9.2" r="0.4" fill="currentColor" />
  </svg>
);

export const BangGlyph: React.FC = () => (
  <svg {...g}>
    <circle cx="6.5" cy="6.5" r="5" />
    <line x1="6.5" y1="3.5" x2="6.5" y2="7.5" />
    <circle cx="6.5" cy="9.4" r="0.4" fill="currentColor" />
  </svg>
);

export const CheckGlyph: React.FC = () => (
  <svg {...g} strokeWidth={1.6}>
    <path d="M2.5 6.5 L5.5 9.5 L11 4" />
  </svg>
);

export const ShareGlyph: React.FC = () => (
  <svg {...g}>
    <circle cx="3.5" cy="6.5" r="1.5" />
    <circle cx="9.5" cy="3" r="1.5" />
    <circle cx="9.5" cy="10" r="1.5" />
    <line x1="4.8" y1="5.7" x2="8.2" y2="3.7" />
    <line x1="4.8" y1="7.3" x2="8.2" y2="9.3" />
  </svg>
);

export const PdfGlyph: React.FC = () => (
  <svg {...g}>
    <path d="M3 1 L9 1 L11 3 L11 12 L3 12 Z" />
    <line x1="4.8" y1="8.6" x2="9.2" y2="8.6" />
    <line x1="4.8" y1="10.4" x2="7.6" y2="10.4" />
  </svg>
);

export const EditGlyph: React.FC = () => (
  <svg {...g}>
    <path d="M2 11 L3 8.5 L9.5 2 L11.5 4 L5 10.5 Z" />
  </svg>
);

export const ClockGlyph: React.FC = () => (
  <svg {...g}>
    <circle cx="6.5" cy="6.5" r="5" />
    <path d="M6.5 3.4 V6.6 L8.8 8" />
  </svg>
);
